import { createContext, useContext, Dispatch, SetStateAction } from 'react'

import { StoreProgramResponse } from '../../services/storeProgramService'

export interface BulkOrderVariantInputState {
  quantity: number
  errorMessage?: string
  sizeLabel: string
}

export interface StorefrontModeContextState {
  isB2BMode: boolean
  isB2BSelfService: boolean
  storeProgramResponse?: StoreProgramResponse
  b2bSimilarProductIds?: string[]
  setB2BSimilarProductIds?: (productIds: string[]) => void
  isB2BSimilarProductsLoading: boolean
  setIsB2BSimilarProductsLoading?: (isLoading: boolean) => void
  bulkOrderInputStateByVariantId?: Record<string, BulkOrderVariantInputState>
  setBulkOrderInputStateByVariantId?: Dispatch<SetStateAction<Record<string, BulkOrderVariantInputState>>>
  isCustomizationEnabled: boolean
  setIsCustomizationEnabled?: Dispatch<SetStateAction<boolean>>
}

export const StorefrontModeContext = createContext<StorefrontModeContextState>({
  isB2BMode: false,
  isB2BSelfService: false,
  b2bSimilarProductIds: [],
  isB2BSimilarProductsLoading: true,
  isCustomizationEnabled: false,
})

export const useStorefrontModeContext = () => {
  const context = useContext(StorefrontModeContext)

  return context
}
